import { Auth } from '@aws-amplify/auth';
import { AppProvider as SharedAppProvider } from '@cfra-nextgen-frontend/shared/src/providers/AppProvider';
import { getQueryClient } from '@cfra-nextgen-frontend/shared/src/lib/react-query-client';
import { configureAmplify } from 'config/auth';
import { QueryCache } from 'react-query';
import { AppRoutes } from '../routes/AppRoutes';

configureAmplify();

function isAuthError(value: unknown): boolean {
    if (!value || typeof value !== 'object') return false;
    // Infinite query shape: { pages: [...], pageParams: [...] }
    const pages = (value as any)?.pages;
    if (Array.isArray(pages) && pages.length > 0) return isAuthError(pages[0]);
    const { isErroredResponse, statusCode } = value as any;
    if (isErroredResponse && (statusCode === 401 || statusCode === 403)) return true;
    const status = (value as any)?.response?.status ?? (value as any)?.status;
    return status === 401 || status === 403;
}

const signOut = () => Auth.signOut().catch(() => {});

const queryClient = getQueryClient(
    undefined,
    undefined,
    new QueryCache({
        onSuccess: (data) => {
            if (isAuthError(data)) signOut();
        },
        onError: (error) => {
            if (isAuthError(error)) signOut();
        },
    }),
);

export function AppProvider() {
    return <SharedAppProvider appRoutesJsx={<AppRoutes />} queryClient={queryClient} />;
}